import { atom } from 'jotai';

import { availableStoresAsyncAtom } from './availableStoresAsyncAtom';
import { storeIdAtom } from './storeIdAtom';
export const selectedStoreAsyncAtom = atom(async (get) => {
  const storeId = get(storeIdAtom);

  if (storeId) {
    const availableStores = await get(availableStoresAsyncAtom(false));
    return (
      availableStores && availableStores.find((store) => store.id === storeId)
    );
  }
});
